import React, { useEffect, useRef } from 'react';

import './styles.scss';

const EditorHtmlComponent = ({ onUpdate, editorInfo }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    return () => {
      onUpdate({ id: editorInfo.objectId, data: el.value });
    };
  }, []);

  const onWheel = (e) => {
    const { deltaY } = e;
    ref.current.scrollTop += deltaY;
    e.preventDefault();
    e.stopPropagation();
  };

  useEffect(() => {
    if (ref.current) {
      ref.current.addEventListener('wheel', onWheel, { passive: false });
    }
    return () => {
      if (ref.current) {
        ref.current.removeEventListener('wheel', onWheel, { passive: false });
      }
    };
  }, [ref.current]);

  return (
    <>
      <div
        className="mo__editor"
        style={{
          display: 'block',
          top: editorInfo.y,
          left: editorInfo.x,
          width: editorInfo.w,
          height: editorInfo.h,
        }}
      >
        <textarea ref={ref} defaultValue={editorInfo.data} />
      </div>
    </>
  );
};

export default EditorHtmlComponent;
